export default function PHP_ftp_size() {
  return (
    <div>
      <h1>PHP_ftp_size</h1>
    </div>
  );
}
